import {Action, createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import * as fromActions from './core.actions';
import {LoggedUserDataModel} from '../modules/rest/user/response/logged-user-data.model';
import {AppStateNameEnum} from '../enums/app-state-name.enum';

export const REDUCER_NAME = AppStateNameEnum.feature_core;

export interface State {
    loggedUserData: LoggedUserDataModel;
}

const initialState: State = {
    loggedUserData: null
};

const stateSelector = createFeatureSelector<State>(REDUCER_NAME);

export const loggedUserDataSelector = createSelector(stateSelector, (state: State) => state.loggedUserData);

const innerReducer = createReducer(
    initialState,
    on(fromActions.GetLoggedUserData, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.GetLoggedUserDataSuccess, ((state: State, {loggedUserData}): State => ({
        ...state,
        loggedUserData
    }))),
    on(fromActions.UpdateUserPersonalSettings, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.UpdateUserPersonalSettingsSuccess, ((state: State, {settings}): State => ({
        ...state,
        loggedUserData: {
            ...state.loggedUserData,
            personalSettings: settings
        }
    })))
);

export function coreReducer(state: State | undefined, action: Action): State {
    return innerReducer(state, action);
}

